import { Slot } from '@radix-ui/react-slot';
import { VariantProps } from 'class-variance-authority';
import { PropsWithChildren, forwardRef } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

import { buttonVariants } from './Button.cva';

type ButtonProps = Omit<VariantProps<typeof buttonVariants>, 'interactive'> &
  PropsWithClassName<
    PropsWithChildren<{
      type?: 'button' | 'submit';
      title?: string;
      disabled?: boolean;
      asChild?: boolean;
      onClick?: () => void;
    }>
  >;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ title, size, asChild = false, type, disabled, variant, className, children, onClick }, ref) => {
    const Comp = asChild ? Slot : 'button';

    return (
      <Comp
        ref={ref}
        type={asChild ? type : type ?? 'button'}
        title={title}
        className={cn(buttonVariants({ variant, size }), className)}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </Comp>
    );
  }
);

Button.displayName = 'Button';
